module.exports = __webpack_public_path__ + "c26d4d68b759a996a406137ae3125e94.svg";